<div itemscope id="container" class="ui-g-12 ui-md-offset-2 ui-sm-offset-2">
    <div itemscope class="ui-g-4 ui-sm-8 p-grid p-dir-col">
        <div itemscope class="p-col">
            <h2>Contact me</h2>
            <p>E-mail: <a href="mailto:lejdipriftidigitalservices@gmail.com">lejdipriftidigitalservices@gmail.com</a>
            </p>
            <p>Address: <a
                    href="https://www.google.com/search?rlz=1C1GCEA_enAL752AL752&tbm=lcl&sxsrf=ALeKk01KJZoXxC2DOuwllPzbFBW69kYu4g%3A1584290281222&ei=6VluXvKXDbHJmwWYtprQCw&q=AnA+Residences%2C+prane+Qytetit%2C+Tirana&oq=ana+residences+tirana&gs_l=psy-ab.1.1.0i22i30k1j38.36611.40542.0.42536.21.18.0.0.0.0.331.2814.0j8j2j3.13.0....0...1c.1.64.psy-ab..8.13.2802...0j35i39k1j0i273k1j0i131k1j0i131i67k1j0i10k1.0.EYxI4lYdLNE#rlfi=hd:;si:2363637852741807902;mv:[[41.32002877731903,19.83921683891447],[41.31966882268097,19.838737561085527]]">
                    Pjeter Budi St., Tirana, Albania</a></p>
        </div>
        <div itemscope class="p-col">
            <h2>Social Media</h2>
            <a class="social" href="https://www.linkedin.com/in/lejdi-prifti/"><img
                    src="assets/images/social/linkedin.png" alt="linkedin"></a>
            <a class="social" href="https://github.com/lejdiprifti"><img src="assets/images/social/github-image.png"
                    alt="github"></a>
        </div>
        <div class="p-col">

            <!-- Put this code anywhere in the body of your page where you want the badge to show up. -->

            <div itemscope itemtype='http://schema.org/Person' class='fiverr-seller-widget'
                style='display: inline-block;'>
                <a itemprop='url' href="https://www.fiverr.com/lejdi_prifti" rel="nofollow" target="_blank"
                    style='display: inline-block;'>
                    <div class='fiverr-seller-content'
                        id='fiverr-seller-widget-content-baa90e74-11fd-428f-857d-a4b52a4a36e1' itemprop='contentURL'
                        style='display: none;'></div>
                    <div id='fiverr-widget-seller-data' style='display: none;'>
                        <div itemprop='name'>lejdi_prifti</div>
                        <div itemscope itemtype='http://schema.org/Organization'><span itemprop='name'>Fiverr</span>
                        </div>
                        <div itemprop='jobtitle'>Seller</div>
                        <div itemprop='description'>I am a professional social media manager and software developer
                            passionate about technology and business. I have a long and enriched experience on digital
                            marketing.
                            I have developed websites for businesses using WordPress technologies and empowered their
                            brand by growing the audience and engagement in Social Media.

                            Furthermore, as a software developer, I have the right knowledge of building high-quality
                            software and websites for every interested business. I have previously worked with Italian,
                            Dutch and Swedish brands on software development and branding. Your success defines my
                            success! </div>
            </div>
            </a>
            </div>
        </div>
    </div>
    <div class="ui-g-5 ui-sm-9">
        <h1>Send me a message</h1>
        <form role="form" [formGroup]="userform">
            <fieldset>
                <legend>Fill in your details</legend>
                <div class="form-group info">
                    <legend>First Name</legend>
                    <input type="text" formControlName="firstName" pInputText pKeyFilter="alpha"
                        placeholder="First Name">
                    <p-message class="message" severity="error" text="First Name is required"
                        *ngIf="!userform.controls['firstName'].valid && userform.controls['firstName'].dirty">
                    </p-message>
                </div>
                <div class="form-group info">
                    <legend>Last Name</legend>
                    <input type="text" formControlName="lastName" pInputText pKeyFilter="alpha" placeholder="Last Name">
                    <p-message class="message" severity="error" text="Last Name is required"
                        *ngIf="!userform.controls['lastName'].valid && userform.controls['lastName'].dirty"></p-message>
                </div>
                <div class="form-group info">
                    <legend>E-mail</legend>
                    <input type="text" formControlName="email" pInputText pKeyFilter="email" placeholder="E-mail">
                    <p-message class="message" severity="error" text="Valid email is required"
                        *ngIf="!userform.controls['email'].valid && userform.controls['email'].dirty"></p-message>
                </div>
                <div class="form-group info">
                    <legend>Message</legend>
                    <textarea pInputTextarea formControlName="message"
                        placeholder="Write your message here."></textarea>
                    <p-message class="message" severity="error" text="Message is required"
                        *ngIf="!userform.controls['message'].valid && userform.controls['message'].dirty"></p-message>
                </div>
                <div class="form-group info">
                    <button pButton label="Send" [disabled]="userform.invalid" icon="fa fa-paper-plane" (click)="send()"
                        class="ui-button-raised ui-button-success"></button>
                    <button pButton label="Reset" (click)="reset()" icon="pi pi-times"
                        class="reset ui-button-raised ui-button-secondary"></button>
                </div>
            </fieldset>
        </form>
    </div>
</div>